import * as Topic from '../../services/api/topic'
import { useApiRequest } from '../useApiRequest'

export function useTopics (tags) {
  const { data: topics, loading: loadingTopics, error: topicsError } = useApiRequest(Topic.fetchAll(tags))

  return [topics, loadingTopics, topicsError]
}
